// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"99abef0d","455":"6346b5f2","977":"3bf07a94"}[chunkId] + ".chunk.js";
};